export default __webpack_public_path__ + "static/Find-Endless-inspiration-d912aedccfe9008e6c13fbaddbb2f5a7.jpg";